module.exports = __webpack_public_path__ + "img/地图-浅色镂空.1d3d3c37.png";